import { useQuery } from '@tanstack/react-query'
import request from 'api'
import { AxiosError } from 'axios'

export interface CountriesData {
  [countryCode: string]: {
    adultAge?: number
    childAccount: {
      childAccountSupported?: boolean
      minorAge: number
    }
  }
}

export interface CountriesResponse {
  countries: CountriesData
}

const fetchCountries = async () => {
  const response = await request.get<CountriesResponse>(`${process.env.REACT_APP_POLICY_URL}/v1/countries`)

  if (response.status !== 200) {
    throw new AxiosError('fetching countries failed.', undefined, response.config, response.request, response)
  }

  return response.data
}

const useCountriesQuery = () => {
  const { data, isLoading, isFetching, isError, error } = useQuery<CountriesResponse, AxiosError>({
    queryKey: ['countries'],
    queryFn: () => fetchCountries()
  })
  return { data, isLoading, isFetching, isError, error }
}

export default useCountriesQuery
